import { ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Column } from "../../../../Components/Tables/Table";
import { prepareSearchColumns } from "../../../../Utility/Utility";
import AllocationList from "../../List/AllocationList";
import toast, { Toaster } from "react-hot-toast";
import { deleteAllocationPlanById } from "../service/allocation.service";
import CommonConfirmationModal from "../../../../Components/Modals/CommonConfirmationModal";
import { ApiResponse } from "../../../../model/common/apiResponse";

interface OutboundAllocationProps {
  pageName: string;
  headerName: string;
}

const defaultProps: OutboundAllocationProps = {
  pageName: "Allocation",
  headerName: "Allocations",
};
export default function AllocationPlanOverview(props: OutboundAllocationProps) {
  const navigation = useNavigate();
  const [data, setData] = useState<any>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleRowClick = (row: any) => {
    navigation(`/outbound/allocations/details/${row.id}`);
  };
  const { pageName, headerName} = props;
  const [confirmModalData, setConfirmModalData] = useState({
    id: 0,
    showconfModal: false,
    message: "",
  });

  let columns: Column[];
  columns = [
    {
      name: "Allocation Id",
      selector: (row: { id: string }) => (
        <span
          className="cursor-pointer text-primary"
          onClick={() => handleRowClick(row)}
        >
          {row.id}
        </span>
      ),
      enableSorting: true,
    },
    {
      name: "Description",
      selector: (row: { description: number }) => row.description,
      enableSorting: true,
    },
    {
      name: "Client",
      selector: (row: { client: string }) => (row.client ? row.client : "-"),
      enableSorting: true,
    },
    {
      name: "Warehouse",
      selector: (row: { warehouse: string }) =>
        row.warehouse ? row.warehouse : "-",
      enableSorting: true,
    },
    {
      name: <></>,
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleRowClick(row)}
            >
              View
            </li>
                  <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleEditAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleDeleteAction(row)}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];

  const db_columns = [
    {
      data: "allocation_config.id",
    },
    {
      data: "client.name as client",
    },
    {
      data: "warehouse.name as warehouse",
    },
    {
      data: "allocation_config.description",
    },
  ];
  const exclude_columns = ["logo_url", "client.is_active"];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);
  const sorting_order = [
    {
      column: "allocation_config.id",
      dir: "desc",
    },
  ];
  const handleconfClose = () => {
    setConfirmModalData({
      id: 0,
      showconfModal: false,
      message: "",
    });
  };

  const onDeleteModalSubmit = async (isAccept: boolean) => {
    if (confirmModalData.id !== 0 && isAccept) {
      deleteAllocationPlanById(confirmModalData.id.toString()).then(
        (response: ApiResponse<any>) => {
          if (response.status == 200) {
            toast.success("Allocation deleted successfully");
            setRefreshTrigger((prev) => prev + 1);
          } else {
            toast.error("Failed to delete the Allocation !");
          }
        }
      );
    }
    handleconfClose();
  };
  const handleDeleteAction = (row: any) => {
    setConfirmModalData({
      id: row.id,
      showconfModal: true,
      message: `Are you sure you want to delete this  Allocation Id ${row.id}?`,
    });
  };
  const handleEditAction = (row: any) => {
    navigation(`/outbound/allocations/edit/${row.id}`);
  };
  return (
    <>
      <Toaster />
      <AllocationList
        pageName={pageName}
        headerName={headerName}
        columns={columns}
        search_columns={search_columns}
        db_columns={db_columns}
        data={data}
        sorting_order={sorting_order}
        refreshTrigger={refreshTrigger}
      />
      <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        content={<>{confirmModalData.message}</>}
        onModalSubmit={onDeleteModalSubmit}
      />
    </>
  );
}
AllocationPlanOverview.defaultProps = defaultProps;